import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    controller: '',

    id: 0,
    fechaVigenciaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaVigenciaHasta: moment(new Date()).format('YYYY-MM-DD'),
    indicadorSemestre: null,
    indicadorSemestreNombre: null,
    indicadorAnio: null,
    plazoObjetivo: 0,
    descripcion: '',
    rowVersion: null,

    /* Información del indicador del período anterior */
    indicadorPeriodoAnterior: '',
    plazoObjetivoAnterior: 0,
    plazoResultadoAnterior: 0,

    indicadorDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, params) {
        state.controller = params.controller;

        state.id = params.indicadorId;
        state.fechaVigenciaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.indicadorSemestre = null;
        state.indicadorSemestreNombre = null;
        state.indicadorAnio = null;
        state.plazoObjetivo = 0;
        state.descripcion = '';
        state.rowVersion = null;

        state.indicadorPeriodoAnterior = '';
        state.plazoObjetivoAnterior = 0;
        state.plazoResultadoAnterior = 0;
    },
    'SET_INDICADOR'(state, indicador) {
        state.fechaVigenciaDesde = moment(indicador.fechaVigenciaDesde).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(indicador.fechaVigenciaHasta).format('YYYY-MM-DD');
        state.indicadorSemestre = indicador.indicadorSemestre;
        state.indicadorSemestreNombre = indicador.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre';
        state.indicadorAnio = indicador.indicadorAnio;
        state.plazoObjetivo = indicador.plazoObjetivo;
        state.descripcion = indicador.descripcion.trim();
        state.rowVersion = indicador.rowVersion;
    },
    'SET_RESULTADO_INDICADOR_ANTERIOR'(state, indicador) {
        state.indicadorPeriodoAnterior = indicador.indicadorPeriodo;
        state.plazoObjetivoAnterior = indicador.plazoObjetivo;
        state.plazoResultadoAnterior = indicador.plazoActual;
    },

    'INICIALIZAR_DATOS' (state) {
        state.indicadorDatos = [];
    },
    'SET_DATOS' (state, indicadorDatos) {
        state.indicadorDatos = indicadorDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', params);

            if (params.indicadorId != 0) {
                apiAxios.get(params.controller + '/' + params.indicadorId + '/abm' ) 
                    .then(res => {
                        commit('SET_INDICADOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    getResultadosIndicadorAnterior ( { commit } ) {
        return new Promise((resolve, reject) => {
            let queryString = '';
            console.log(state.indicadorSemestreNombre, state.indicadorAnio);
            if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                queryString = '?anio=' + (state.indicadorAnio - 1) + '&semestre=2';
            } else {
                queryString = '?anio=' + state.indicadorAnio + '&semestre=1';
            }

            apiAxios.get('indicadores/plazo-clientes' + queryString)
                .then(res => {
                    commit('SET_RESULTADO_INDICADOR_ANTERIOR', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            if (state.indicadorSemestreNombre.trim() == '1er Semestre') {
                state.indicadorSemestre= 1;
            }
            if (state.indicadorSemestreNombre.trim() == '2do Semestre') {
                state.indicadorSemestre= 2;
            }

            let indicador = {
                fechaVigenciaDesde: moment(state.fechaVigenciaDesde).format('YYYY-MM-DD'),
                fechaVigenciaHasta: moment(state.fechaVigenciaHasta).format('YYYY-MM-DD'),
                indicadorSemestre: parseFloat(state.indicadorSemestre),
                indicadorAnio: parseFloat(state.indicadorAnio),
                plazoObjetivo: parseFloat(state.plazoObjetivo),
                descripcion: state.descripcion.trim(),                
            }

            let url = state.controller;
            if (state.id != 0) {
                url += '/' + state.id;
                indicador.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, indicador)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (params.indicadorId != 0) {
                apiAxios.get(params.controller + '/' + params.indicadorId ) 
                .then(res => {
                    let datos = [
                        { 'nombre': 'indicadorAnio', 'campo': 'Año', 'valor': res.data.indicadorAnio, 'formato': '' },
                        { 'nombre': 'indicadorSemestre', 'campo': 'Semestre', 'valor': res.data.indicadorSemestre == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' },
                        { 'nombre': 'plazoObjetivo', 'campo': 'Plazo Objetivo', 'valor': res.data.plazoObjetivo, 'formato': 'numero' },
                        { 'nombre': 'fechaVigenciaDesde', 'campo': 'Fecha Vigencia - Desde', 'valor': res.data.fechaVigenciaDesde, 'formato': 'fecha' },
                        { 'nombre': 'fechaVigenciaHasta', 'campo': 'Fecha Vigencia - Hasta', 'valor': res.data.fechaVigenciaHasta, 'formato': 'fecha' },
                        { 'nombre': 'descripcion', 'campo': 'Descripcion', 'valor': res.data.descripcion.trim(), 'formato': '' }
                    ];
                    
                    commit('SET_DATOS', datos);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}